import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Leaf } from 'lucide-react';
import { TopographicPattern } from './SectionDivider';
export function TestimonialsSection() {
  const testimonials = [{
    text: "My yard has never looked so good. The EITHAN team was professional, friendly, and the results were absolutely stunning. I couldn't be happier!"
  }, {
    text: 'They removed all the old junk from my backyard and completely transformed the space. It feels like a brand new property. Thank you EITHAN!'
  }, {
    text: 'From the flower beds to the gutters — everything was done perfectly. I finally have the yard I always wanted. These guys are the best in Chattanooga!'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-237">
      <TopographicPattern className="text-brand-gold opacity-10" data-id="element-238" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-241">
            Why Families Across Chattanooga & North Georgia Love EITHAN
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-242">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-brand-black p-8 rounded-2xl shadow-sm border border-brand-gold/10 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-243">
              <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-244">
                <Leaf size={100} className="text-brand-gold" data-id="element-245" />
              </div>

              <div className="flex gap-1 mb-6 text-brand-gold relative z-10" data-id="element-246">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-247" />)}
              </div>
              <p className="text-lg text-gray-300 italic leading-relaxed relative z-10" data-id="element-248">
                "{testimonial.text}"
              </p>
              <div className="absolute top-6 right-6 text-brand-gold/5" data-id="element-249">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-250">
                  <path d="M14.017 21L16.411 14.529C16.635 13.913 16.75 13.265 16.75 12.603V4H23V12.603C23 15.358 22.188 17.95 20.697 20.081C19.206 22.212 17.114 23.766 14.717 24L14.017 21ZM3.017 21L5.411 14.529C5.635 13.913 5.75 13.265 5.75 12.603V4H12V12.603C12 15.358 11.188 17.95 9.697 20.081C8.206 22.212 6.114 23.766 3.717 24L3.017 21Z" data-id="element-251" />
                </svg>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}